import { render, staticRenderFns } from "./RecordTableReferenceNumberWithHint.vue?vue&type=template&id=21dabbe9"
import script from "./RecordTableReferenceNumberWithHint.vue?vue&type=script&lang=js"
export * from "./RecordTableReferenceNumberWithHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports